<template>
  <div>
    <template v-for="navMenu in navMenus">
      <!-- 最后一级菜单 -->
      <el-menu-item
        v-if="!navMenu.children"
        :key="navMenu.id"
        :data="navMenu"
        :index="navMenu.path"
        @click.native="routingpath(navMenu)"
      >
        <span slot="title">{{ navMenu.label }}</span>
      </el-menu-item>
      <!-- 此菜单下还有子菜单 -->
      <el-submenu
        v-if="navMenu.children"
        :key="navMenu.id"
        :data="navMenu"
        :index="navMenu.path"
      >
        <template slot="title">
          <span> {{ navMenu.label }}</span>
        </template>
        <!-- 递归 -->
        <NavMenu :navMenus="navMenu.children" v-on="$listeners"></NavMenu>
      </el-submenu>
    </template>
  </div>
</template>
<script>
export default {
  name: "NavMenu",
  props: ["navMenus"],
  data() {
    return {};
  },
  created() {},
  methods: {
    routingpath(item) {
      localStorage.setItem("menuChildren", JSON.stringify(item));
      this.$emit("routing", item);
    },
  },
};
</script>
<style scoped>
</style>